export default {
    /* Global Vocabulary */
    error_saving_data: 'ذخیره اطلاعات منجر به خطا شد!',
    name: 'نام',
    first_name: 'نام',
    middle_name: 'نام میانی',
    last_name: 'نام خانوادگی',
    fullname: 'نام و نام خانوادگی',
    gender: 'جنسیت',
    man: 'مرد',
    save: 'ذخیره',
    save_and_continue: 'ذخیره و ادامه',
    woman: 'زن',
    documents: 'اسناد',
    start_typing_the_address: 'شروع به تایپ نشانی کنید...',
    start_typing_new_address: 'شروع به تایپ نشانی جدید کنید...',
    male: 'مرد',
    female: 'زن',
    other: 'دیگر',
    terms_conditions: 'شرایط و ضوابط',
    contact_number: 'شماره تماس',
    preferences: 'تنظیمات شخصی',
    type: 'تایپ کنید',
    type_here: 'اینجا تایپ کنید',
    new_address: 'آدرس جدید',
    submit: 'ثبت',
    language: 'زبان',
    mobile_notifications: 'اعلان‌های موبایل',
    email_notifications: 'اعلان‌های ایمیل',
    address_proof: 'مدرک نشانی محل سکونت',
    send_file_s: 'ارسال فایل(ها)',
    verified: 'تأیید شده',
    unverified: 'تأیید نشده',
    dismiss: 'بستن',
    account_number: 'شماره حساب',

    /* Module special vocabulary */
    users: {
        menu: {
            index: 'کاربران',
            create: 'ایجاد کاربر',
            list: 'لیست کاربران',
            profile: 'پروفایل',
            account: 'پروفایل',
            rewards: 'هدایا'
        },
        table_titles: {
            id: 'شناسه',
            gender: 'جنسیت',
            first_name: 'نام',
            middle_name: 'نام میانی',
            last_name: 'نام خانوادگی',
            date_of_birth: 'تاریخ تولد',
            introducer: 'معرف',
            mobile: 'موبایل',
            country: 'کشور',
            email: 'ایمیل',
            address: 'نشانی',
            verify_identity: 'احراز هویت',
            account_type: 'نوع حساب',
            ecdd: 'ECDD',
            is_blocked: 'مسدود',
            notes: 'یادداشت‌ها',
            acl: 'سطح دسترسی',
            email_verification_status: 'تأیید ایمیل',
            registered_at: 'تاریخ عضویت',
            last_login_at: 'آخرین ورود',
            setting: 'ویرایش / حذف',
        },
        refresh: 'به‌روز رسانی',
        your_profile_saved_successfully: 'پروفایل شما با موفقیت ذخیره شد',
        country_of_id_document: "کشور مدرک شناسایی",
        id_document_type: 'نوع سند',
        id_number: 'شماره کارت شناسایی',
        passport_number: 'شماره گذرنامه',
        licence_number: 'شماره گواهینامه',
        expiry_date: 'تاریخ انقضاء',
        account_info: {
            my_details: 'مشخصات من',
            limits: 'سقف انتقال',
            rewards: 'هدایا',
            verification: 'احراز هویت',
            security: 'امنیت',
            status: {
                verified: 'تأیید شده',
                unverified: 'تأیید نشده',
                verifying: 'در حال بررسی',
            },
            verify_account: 'تأیید حساب',
            my_bank_accounts: 'حساب‌های بانکی من',
            add_your_bank_account: 'افزودن حساب بانکی',
            account_name_must_be: 'نام صاحب حساب',
            verification_is_not_completed: 'احراز هویت شما تکمیل نشده است!',
            which_bank_do_you_pay_from: 'از کدام بانک پرداخت می‌کنید؟',
            bank_name: 'بانک',
            account_number: 'شماره حساب',
            upload_proof_of_account: 'ارسال مدارک حساب بانکی',
            send_proof_of_account: 'ارسال مدارک حساب بانکی',
            your_documents_were_successfully_submitted: 'مدارک شما با موفقیت ارسال شدند.'
        },
        id_document_type_labels: {
            driver_licence: 'گواهینامه رانندگی',
            passport: 'گذرنامه',
            identification_card: 'کارت شناسایی'
        },
        id_document_types:{
            whats_your_id_document: 'مدرک شناسایی شما چیست؟',
            new_zealand_drivers_licence: 'گواهینامه‌ رانندگی نیوزلند',
            new_zealand_passport: 'گذرنامه نیوزلند',
            australian_drivers_licence: 'گواهینامه رانندگی استرالیا',
            australian_passport: 'گذرنامه استرالیا',
            other: 'سایر مدارک'
        },
        additional_documents: 'اسناد تکمیلی',
        when_required_attach_all_files_to_send_your_supporting_documents: 'در صورت نیاز به ارائه اسناد تکمیلی، مدارک را از اینجا پیوست و ارسال کنید.',
        verify_email: 'تأیید ایمیل',
        needs_action: 'نیازمند اقدام',
        check_your_email_now_to_verify_your_email_address: 'ایمیل خود را چک کرده و روی لینک تأیید کلیک کنید.',
        if_you_haven_t_received_any_emails: 'اگر هنوز ایمیلی دریافت نکرده‌اید، صحت آدرس‌تان را چک کنید و یا از دکمه ارسال استفاده کنید.',
        change: 'ویرایش',
        send_verification_email: 'ارسال ایمیل تأیید',
        check_your_email: 'ایمیلتان را چک کنید',
        if_you_didn_t_receive_any_emails: 'اگر هیچ ایمیلی دریافت نکرده‌اید',
        wait_for_some_minutes: 'چند دقیقه صبر کنید.',
        double_check_your_email_address_for_spelling_mistakes: 'به منظور اطمینان از عدم خطاهای تایپی آدرس ایمیتان را مجدداً چک کنید.',
        check_your_spam: 'اسپم را چک کنید.',
        you_can_try_again_after_60_seconds: 'پس از ۶۰ ثانیه می‌توانید مجدداً تلاش کنید.',
        please_check_your_email_and_click_on_verify_email_link: 'لطفاً ایمیلتان را بررسی و روی عبارت Verify email کلیک کنید.',
        your_email_has_been_updated_successfully: 'ایمیل شما با موفقیت به روز رسانی شد!',
        begin_verification: 'Begin verification',
        text_me_now: 'به من پیامک بده',
        starting_process: 'Starting...',
        email_verified: 'ایمیل تأیید شد',
        personal_info: 'اطلاعات فردی',
        verify_identity_address: 'تأیید هویت و آدرس',
        oops_your_identification_result_is_failed: 'متأسفانه احراز هویت شما تأیید نشد.',
        i_live_in: 'کشور محل سکونت',
        prepare_your_passport: 'پاسپورت خود را آماده کنید',
        biometrics_verification_only_works_on_a_smartphone_or_tablet: 'تأیید بیومتریک فقط روی گوشی هوشمند یا تبلت کار می‌کند. اگر از کامپیوتر استفاده می‌کنید، کد QR را در صفحه بعدی با دوربین گوشی اسکن کنید.',
        verification_link_also_copied_in_your_clipboard: 'لینک احراز هویت در کلیپ‌بورد شما نیز کپی شده است. اگر دکمه START… برای شما کار نکرد، لینک را در مرورگر Chrome موبایل خود کپی کنید.',
        verification_link_copied: 'لینک احراز هویت کپی شد.',
        account_type: 'نوع حساب',
        address: 'نشانی محل سکونت',
        personal: 'حقیقی',
        business: 'حقوقی',
        verification_method: 'روش احراز هویت',
        manual: 'دستی',
        automatic: 'خودکار',
        for_business_accounts_please_fill_in: 'برای حساب‌های تجاری لطفاً {form} را تکمیل فرمایید.',
        rebit_business_account_form: 'فرم حساب تجاری ربیت',
        we_ll_update_your_verification_status_accordingly: 'ما بر این اساس وضعیت احراز هویت شما را به‌روزرسانی می‌کنیم.',
        information_submitted: 'اطلاعات ثبت شد',
        select_new_zealand_or_australia_for_nz_and_aus_driver_s_licence_or_passport: 'نیوزلند یا استرالیا را برای گواهینامه رانندگی یا پاسپورت NZ و AUS انتخاب کنید.',
        select_iran_if_you_re_sending_an_iranian_passport_as_your_id_document: 'اگر پاسپورت ایرانی را به عنوان مدرک شناسایی خود ارسال می‌کنید، ایران را انتخاب کنید.',
        click_on_the_link_in_your_txt_to_complete_your_verification: 'برای تکمیل احرازهویت روی لینک داخل پیامک کلیک کنید.',
        prepare_your_id_document: 'مدرک شناسایی خود را آماده کنید.',
        if_this_method_didn_t_work_for_you_please_send_your_details_documents_via_the_manual_method: 'اگر این روش برای شما جواب نداد، لطفاً مشخصات/اسناد خود را از طریق روش دستی ارسال کنید.',
        we_already_sent_you_a_text_message_with_a_link_click_on_the_link_in_your_sms_to_start: 'ما قبلا یک پیامک همراه با لینک برای شما ارسال کردیم. برای شروع روی لینک موجود در پیامک خود کلیک کنید.',
        once_done_with_aply_id_don_t_forget_to_come_back_and_refresh_to_see_the_results_here: 'پس از اتمام کار با AplyID، فراموش نکنید که برگردید و رفرش کنید تا نتایج را در اینجا ببینید!',
        if_you_didn_t_get_an_sms_you_can_try_again_after_2_minutes: 'اگر پیامکی دریافت نکردید، می‌توانید بعد از ۲ دقیقه دوباره امتحان کنید.',
        sms_sent: 'پیامک ارسال شد',
        id_verified_successfully: 'تأیید مشخصات و آدرس',
        send_money: 'پول بفرستید',
        under_review: 'در دست بررسی...',
        action_required: 'نیاز به اقدام!',
        we_are_working_on_it: 'ما در حال بررسی هستیم!',
        thanks_for_starting_your_verification_process: 'از اینکه فرآیند احراز هویت را آغاز کرده‌اید سپاسگزاریم.',
        we_are_verifying_your_details_and_will_get_back_to_you_asap_meanwhile: 'ما در حال بررسی اطلاعات شما هستیم و در اسرع وقت با شما تماس خواهیم گرفت. در طول این فرآیند، گوشه چشمی به Inbox/Spam خود داشته باشید',
        we_ll_confirm_your_verification_via_email: 'ما احراز هویت شما را از طریق ایمیل اعلام می‌کنیم.',
        or_we_may_ask_you_to_upload_the_missing_files_here: 'یا ممکن است از شما بخواهیم فایل‌های دیگری را در اینجا آپلود کنید.',
        contact_us: 'با ما تماس بگیرید',
        help_and_support: 'پشتیبانی',
        share_rebit_earn_cash: 'رِبیت را به اشتراک بگذارید و پاداش بگیرید!',
        share_rebit_earn_money: 'رِبیت را به اشتراک بگذارید و {money} پاداش بگیرید!',
        share_your_reward_link: 'لینک پاداش را به اشتراک بگذارید',
        your_friend_must_use_your_link_to_sign_up: 'دوستان شما باید از طریق این لینک ثبت‌نام کنند.',
        sign_up_using_this_link_to_receive_rewards: 'جهت دریافت پاداش از این لینک استفاده کنید!',
        you_ll_receive_a_n_reward: 'شما {n} دریافت خواهید کرد.',
        when_they_send_n_currency_or_more_within_30_days: 'مادامی که عضو جدید در ۳۰ روز اول ثبت نامش حداقل {n} {currency} ارسال کند.',
        they_ll_also_receive_a_n_currency_reward: 'آنها هم یک پاداش {n} {currency} می‌گیرند.',
        terms_conditions_apply : 'شرایط و ضوابط اعمال می‌شود.',
        don_t_miss_out_on_your_referral_reward: 'پاداش معرفی کردن را از دست ندهید!',
        verify_to_redeem: 'برای بازخرید تأیید کنید',
        your_reward_expires_in_remaining_days_day: 'پاداش شما {day} روز دیگر منقضی می‌شود.',
        complete_verification_to_generate_your_reward_link: '{complete_verification} تا لینک پاداش را دریافت نمایید.',
        complete_verification: 'پروفایل خود را کامل کنید',
        rewards_summary: 'خلاصه پاداش‌ها',
        reward_link: 'لینک پاداش',
        rewarded_user: 'کاربر',
        rewarded_users: 'کاربر',
        joined_friends: 'عضویت با لینک شما',
        cash_earned: 'جمع کل پاداش‌ها',
        savings_to_date: 'پاداش‌های خرج شده',
        unused_rewards: 'پاداش‌های استفاده نشده',
        how_it_works: 'نحوه کارکرد سیستم پاداش‌ها',
        number_of_users_joined_via_your_link: 'تعداد کاربرانی که از طریق لینک عضو شده‌اند.',
        total_rewards_earned_to_date_you_only_earn_rewards: 'مجموع پاداش‌ها کسب شده تا امروز. شما فقط زمانی پاداش‌ها دریافت می‌کنید که کاربر دعوت شده حداقل مبلغی را ظرف ۳۰ روز پس از ثبت نام ارسال کند.',
        you_earn_rewards_in_the_currency_of_your_residential_country: 'شما به واحد پول کشور محل اقامت خود پاداش دریافت می‌کنید. هنگامی که پول ارسال می کنید و ارز پرداختی شما یکسان است، می توانید از پاداش‌ها خود استفاده کنید.',
        the_discounts_you_received_on_your_previous_orders_due_to_the_rewards_earned: 'تخفیف‌هایی که در سفارشات قبلی خود به دلیل پاداش‌ها کسب شده دریافت کرده‌اید.',
        your_balance_to_be_redeemed_in_future_orders: 'موجودی شما در سفارشات بعدی بازخرید می‌شود.',
        we_will_show_your_personal_details_here_once_you_completed_your: 'ما اطلاعات شخصی شما را پس از تکمیل {verification} نمایش خواهیم داد.',
        verification: 'احراز هویت',
        email_notifications: 'اعلان‌های ایمیل',
        mobile_notifications: 'اعلان‌های موبایل',
        important_order_updates: 'سفارشات در حال پردازش',
        essential_emails_related_to_your_order_status: 'ایمیل‌های کلیدی مرتبط با وضعیت سفارش شما',
        reminders: 'یادآوری‌ها',
        optional_account_updates_and_key_dates: 'یادآوری‌های مربوط به حساب کاربری',
        ideal_exchange_rates: 'نرخ‌های ایده‌آل',
        optional_market_updates_based_on_your_preferred_routes: 'نوسانات بازار بر اساس ارزهای موردعلاقه شما',
        announcements_special_offers: 'اطلاعیه‌ها و پیشنهادات ویژه',
        optional_rebit_feature_updates_and_great_deals: 'به‌روزرسانی‌های امکانات اپلیکیشن و پیشنهادهای ویژه',
        financial_news: 'اخبار اقتصادی',
        optional_local_highlights_tailored_for_you: 'گزیده‌ی اخبار اقتصادی محلی',
        notify_important_messages_via_whats_app: 'پیام‌های مهم را از طریق واتس‌آپ اطلاع دهید',
        notify_important_messages_via_telegram: 'پیام‌های مهم را از طریق تلگرام اطلاع دهید',
        transfer_limits: 'سقف انتقال',
        monthly_transfer_limits: 'سقف انتقال ماهانه',
        send_supporting_documents_to_increase_your_limits: 'جهت افزایش سقف انتقال، مدارک مرتبط را ارسال کنید.',
        send_documents: 'ارسال اسناد تکمیلی',
        limits_faq: 'راهنمای افزایش سقف',
        do_you_still_live_here: 'هنوز اینجا زندگی می‌کنید؟',
        update_information: 'به روز رسانی اطلاعات',
        yes_i_live_at: 'بله من در {address}... زندگی می‌کنم',
        no_that_s_my_old_address: 'نه، این آدرس قدیمی من است',
        edit_details: 'ویرایش اطلاعات',
        new_address: 'نشانی جدید',
        upload_new_address_proof: 'بارگذاری مدرک نشانی محل سکونت',
        send_money_reasons: {
            how_will_you_use_rebit: 'از ربیت چگونه استفاده می‌کنید؟',
            how_will_user_use_rebit: 'کاربر چگونه از ربیت استفاده می‌کند؟',
            choose_all_reasons_for_transfer_that_apply: 'گزینه‌های مرتبط را انتخاب یا مورد دلخواه را وارد کنید.',
            how_often_will_you_use_rebit_to_send_money: 'فکر می‌کنید هر چند وقت یکبار از طریق ربیت پول ارسال کنید؟',
            how_much_do_you_usually_send_per_transfer: 'به طور متوسط، در هر انتقال چه مبلغی ارسال خواهید کرد؟',
            how_often_options: {
                choose_frequency: 'دفعات ارسال را انتخاب کنید',
                every_month: 'ماهانه',
                every_3_6_months: 'هر ۳ تا ۶ ماه یکبار',
                every_year: 'سالی یکبار',
            },
            how_much_options: {
                select_a_range: 'محدوده مبلغ را انتخاب کنید',
                up_to_1000: 'کمتر از ۱۰۰۰ دلار آمریکا',
                _1000_5000_ :'۱۰۰۰ تا ۵۰۰۰ دلار آمریکا',
                over_5000: 'بیش از ۵۰۰۰ دلار آمریکا'
            },
            save_reasons_successfully_message: 'سپاسگزاریم! دلایل انتقال وجه با موفقیت ذخیره شد.'
        }
    }
}
